import {HttpWrapperOptions, httpService} from '../../../shared/httpWrapper';
import {apiUrls} from '../../../shared/constants/urls';
import {getApiRoute} from '../../../shared/pipes/getApiRoute';
import {eCertificatesSlice} from '../../reducers/eCertificates';
import {
  Certificate,
  CertificateInfo,
  Department,
  Seller,
} from '../../../shared/models/api/eCertificatesResponsePayload';
import {throttle} from '../../../shared/pipes';
import {AppThunk} from '../index';
import {downloadFileToDisk} from '../../../shared/pipes/fileHelpers';
import {addNotification} from '../snackbar';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';
import {profileTokenSelector} from '../../selectors/profile';
import {Platform} from 'react-native';
import FileViewer from 'react-native-file-viewer';

export const getActiveCertificates = (): AppThunk => {
  return async (dispatch) => {
    const activeCertificates = await httpService.get<Certificate[]>(
      getApiRoute(apiUrls.getActiveCertificates),
      new HttpWrapperOptions().Wait(true).Errors(true).ThrowException(true),
    );

    if (activeCertificates) {
      dispatch(eCertificatesSlice.actions.setActiveCertificates(activeCertificates));
    }
  };
};

export const getCertificatesHistory = (): AppThunk => {
  return async (dispatch) => {
    const certificatesHistory = await httpService.get<Certificate[]>(
      getApiRoute(apiUrls.getCertificatesHistory),
      new HttpWrapperOptions().Wait(true).Errors(true).ThrowException(true),
    );

    if (certificatesHistory) {
      dispatch(eCertificatesSlice.actions.setCertificatesHistory(certificatesHistory));
    }
  };
};

export const getCertificateInfoById = (id: string): AppThunk => {
  return async (dispatch) => {
    if (!id) return;

    const certificateInfo = await httpService.get<CertificateInfo>(
      getApiRoute(apiUrls.getCertificateInfo, {id}),
      new HttpWrapperOptions().Errors(true).ThrowException(true).Wait(true),
    );
    if (certificateInfo) {
      dispatch(eCertificatesSlice.actions.setCertificateInfo(certificateInfo));
    }
  };
};

export const getSellers = (truId?: string): AppThunk => {
  return async (dispatch) => {
    const sellers = await httpService.get<Seller[]>(
      getApiRoute(apiUrls.getSellers, null, truId ? {truId} : undefined),
      new HttpWrapperOptions().Errors(true).ThrowException(true).Wait(true),
    );
    if (sellers) {
      dispatch(eCertificatesSlice.actions.setSellers(sellers));
    }
  };
};

export const getDepartmentById = (id: string): AppThunk => {
  return async (dispatch) => {
    if (!id) return;

    throttle(async () => {
      const department = await httpService.get<Department>(
        getApiRoute(apiUrls.getDepartmentById, {id}),
        new HttpWrapperOptions().Errors(true).ThrowException(true).Wait(true),
      );
      if (department) {
        dispatch(eCertificatesSlice.actions.setDepartment(department));
      }
    }, 900);
  };
};

export const getCertificateStatementExport = (id: string): AppThunk => {
  return async (dispatch, getState) => {
    try {
      const url = getApiRoute(apiUrls.getCertificateStatementExport, {id});
      const fileName = 'Выгрузка по ЭС.pdf';
      const token = profileTokenSelector()(getState());

      dispatch(eCertificatesSlice.actions.setDownloading(true));

      const result = await downloadFileToDisk(url, fileName, token || undefined);

      dispatch(
        addNotification({
          message: 'Файл успешно загружен',
          type: SnackbarNotificationType.Success,
        }),
      );

      if (Platform.OS !== 'web' && FileViewer) {
        setTimeout(() => {
          FileViewer.open(result, {showOpenWithDialog: true});
        }, 400);
      }
    } catch (error: any) {
      dispatch(
        addNotification({
          message: error?.message || 'Ошибка при загрузке файла',
          type: SnackbarNotificationType.Error,
        }),
      );
    } finally {
      dispatch(eCertificatesSlice.actions.setDownloading(false));
    }
  };
};
